import { z } from "zod"

export const GetShortLinkSchema = z.object({
  hash: z.string().uuid(),
})
